import React from "react";
import styled from "@emotion/styled";
import { motion } from "motion/react";
import { useMDSSession } from "@/mds/components/sessions/session-context/mds-session-context";

type Props = {};

export const MDSSessionSpinnerView: React.FC<Props> = () => {
  const { expandSession } = useMDSSession();

  return (
    <CollapsedSpinnerContainer onClick={expandSession}>
      <SpinnerContent>
        <SmallSpinner
          animate={{ rotate: 360 }}
          transition={{
            duration: 1,
            ease: "linear",
            repeat: Infinity,
          }}
        />
      </SpinnerContent>
    </CollapsedSpinnerContainer>
  );
};

const CollapsedSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey.x50};
  }
`;

const SpinnerContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SmallSpinner = styled(motion.div)`
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-radius: 50%;
  border-top-color: ${({ theme }) => theme.colors.grey.x600};
  mask-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.6) 65%,
    rgba(0, 0, 0, 0) 100%
  );
  will-change: transform;
`;
